import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import ActorCharacterFace from '../../../domain/entities/ActorCharacterFace';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexActorCharacterFacesSuccess: {
      const result = action.payload as PaginatedResult<ActorCharacterFace>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
